module.exports = __webpack_public_path__ + "img/interface_close.ebe4ed6c.png";